import {
  createDatasetCardModel,
  type DatasetResourceBadge,
  type DatasetResourceCardModel,
} from "@/components/dataset/datasetResourceModels";
import type { DatasetTableRow } from "@/page/dataset/DatasetTableRow";

// 리뷰 큐 행을 그리드 카드 모델로 바꾼다. 공용 데이터셋 카드와 같은 구성(Embodiment, 에피소드,
// 길이, 용량, 버전, 담당자)을 그대로 쓴다. 리뷰 큐를 훑을 때 필요한 'Embodiment 미지정'만 뱃지로
// 표시한다. 설정 세부(제안 embodiment, 추가 파일, 카메라)는 카드에서 빼고 창의 데이터셋 리뷰 탭에서
// 본다. `DatasetTableRow`의 담당자는 공용 카드에 그대로 전달한다.
export function createReviewDatasetCardModel(row: DatasetTableRow): DatasetResourceCardModel {
  const model = createDatasetCardModel(row);
  // embodiment 미지정은 표시용일 뿐 어떤 동작도 막지 않는다. 그래서 훑어보기용 뱃지로만 강조한다.
  // 큐에 남을지는 검토 완료(reviewed) 축이 정한다. 배지 근거인 `review_state`는 백엔드가
  // embodiment sentinel에서 파생해 보낸다.
  if (row.review_state !== "needs_review") {
    return model;
  }
  const badges: DatasetResourceBadge[] = [
    {
      label: "Embodiment 미지정",
      title: "하드웨어가 아직 확정되지 않은 Dataset입니다. 노출과 Training은 막지 않습니다.",
    },
  ];
  return { ...model, badges };
}
